module.exports = __webpack_public_path__ + "img/index-home.7fff066e.png";